module.exports = __webpack_public_path__ + "static/aspect-ratio-desktop-a081026f81f920704f3114eedb5d5c21.jpg";